import _ from "underscore";
import React from "react";
import classNames from "classnames";
import { connect } from "@evertrue/et-flux";
import { MobileSheet } from "@evertrue/et-components";
import FilterControl from "apps/prospects/components/filters/filter-control";
import FilterDropdown from "apps/prospects/components/filters/filter-dropdown";
import StageFilterDropdown from "apps/prospects/components/filters/stage-filter-dropdown";
import ResponsiveStore from "apps/layout/stores/responsive-store";
import FilterUtils from "apps/filters/filter-utils";
import PropTypes from "prop-types";

const mapStateToProps = () => ({
  is_mobile: ResponsiveStore.isMobile(),
  is_tablet: ResponsiveStore.isTablet(),
});

class ProspectFilters extends React.Component {
  static displayName = "ProspectFilters";

  static propTypes = {
    stageGroupId: PropTypes.number,
    givingCategoryLabel: PropTypes.string,
    isAssignmentsTab: PropTypes.bool,
    filters: PropTypes.object,
    onClose: PropTypes.func,
    onApply: PropTypes.func,
    className: PropTypes.string,
  };

  static defaultProps = {
    filters: {},
  };

  state = {
    temp_filters: _.cloneData(this.props.filters),
    active_dropdown: {},
  };

  handleChange = (key, value) => {
    let temp_filters = { ...this.state.temp_filters };
    if (_.isNull(value) || (_.isArray(value) && _.isEmpty(value))) {
      temp_filters = _.omit(temp_filters, key);
    } else {
      temp_filters[key] = value;
    }
    this.setState({ temp_filters });
  };

  handleApply = () => {
    // special formatting is needed for the last_gift_date filter because it changes depending
    // on the giving category
    let formatted_last_gift_filter = {};
    const last_gift_filter = this.state.temp_filters.last_gift_date;
    if (last_gift_filter) {
      const { gte, lte } = last_gift_filter;
      formatted_last_gift_filter = {
        last_gift_date: { lte, gte, givingCategoryLabel: this.props.givingCategoryLabel },
      };
    }
    this.props.onApply(_.extend({}, this.state.temp_filters, formatted_last_gift_filter));
  };

  handleReset = () => {
    this.setState({ temp_filters: {} });
    this.props.onApply({});
  };

  handleClickList = (field = {}) => {
    this.setState({ active_dropdown: field });
  };

  handleBack = () => {
    this.handleClickList();
  };

  renderActiveDropdown = () => {
    const { key } = this.state.active_dropdown;
    if (key === "stages") {
      return (
        <StageFilterDropdown
          value={this.state.temp_filters[key]}
          stageGroupId={this.props.stageGroupId}
          onChange={val => {
            this.handleChange(key, val);
          }}
        />
      );
    }
    return (
      <FilterDropdown
        filter={this.state.active_dropdown}
        value={this.state.temp_filters[key]}
        onChange={val => {
          this.handleChange(key, val);
        }}
      />
    );
  };

  render() {
    const is_drillin = !_.isEmpty(this.state.active_dropdown);
    const filters = FilterUtils.getFiltersForTab(this.props.isAssignmentsTab, this.props.givingCategoryLabel);
    const active_dropdown_label = this.state.active_dropdown.label;

    return (
      <MobileSheet
        ref={el => {
          this.body = el;
        }}
        className={classNames("prospect-filters", this.props.className, {
          "is-drillin": is_drillin,
          "is-desktop": !(this.props.is_mobile || this.props.is_tablet),
          "is-mobile": this.props.is_mobile,
        })}
        label={active_dropdown_label || (!this.props.isAssignmentsTab ? "Filter Prospects" : "Filter Assignments")}
        backgroundColor="#FFF"
        headerActionLabel={!is_drillin ? "X" : undefined}
        onHeaderAction={!is_drillin ? this.props.onClose : undefined}
        onBack={is_drillin ? this.handleBack : undefined}
        actions={
          !is_drillin
            ? [
                { label: "Reset Filters", className: "prospect-filters--reset", onClick: this.handleReset },
                { label: "Apply Filters", className: "prospect-filters--apply", onClick: this.handleApply },
              ]
            : null
        }
      >
        <div className={classNames("prospect-filters--body", { "is-drillin": is_drillin })}>
          {is_drillin
            ? this.renderActiveDropdown()
            : _.map(filters, (filter = {}) => {
                return (
                  <FilterControl
                    key={filter.key}
                    filter={filter}
                    current_val={this.state.temp_filters[filter.key]}
                    onChange={this.handleChange}
                    onClickList={this.handleClickList}
                  />
                );
              })}
        </div>
      </MobileSheet>
    );
  }
}

export default connect(
  ProspectFilters,
  [ResponsiveStore],
  mapStateToProps,
);
